import type { AvailabilityTags } from '@fixter/model-ts-capacity/CommonTypes';

export enum CollectionDeliveryTypes {
  GARAGE = 'GarageC&D',
  FIXTER = 'Fixter',
  CUSTOMER = 'CustomerC&D',
  OUT_OF_COVERAGE = 'OutOfCoverage',
  UNKNOWN = 'Unknown',
}

export interface GarageCandidate {
  readonly garageId: string;
  readonly businessName: string;
  readonly description: string;
  readonly mainImage?: string;
  readonly addressLine1: string;
  readonly addressLine2: string;
  readonly addressLine3: string;
  readonly city?: string;
  readonly county?: string;
  readonly postcode: string;
  readonly latitude?: number;
  readonly longitude?: number;
  readonly straightLineDistanceMiles: number;
  readonly straightLineDistanceKilometres: number;
  readonly reviews?: {
    readonly name: string;
    readonly rating: number;
    readonly comment: string;
  }[];
  readonly waitingRoom?: boolean;
  readonly courtesyCar?: boolean;
  readonly totalYrsOfExperience?: string;
  readonly totalBookingsCompletedWithFixter?: string;
  readonly isQuoteEligible?: boolean;
  readonly quoteNotEligibleProducts?: string[];
  readonly openingHour: string;
  readonly closingHour: string;
}

interface Slot {
  readonly hour: string;
  readonly availability?: AvailabilityTags;
  readonly price: number;
  readonly cndOption?: CollectionDeliveryTypes;
}

export interface SlotRule {
  readonly date: string;
  readonly available: boolean;
  readonly slots: Slot[];
}

export interface JourneyData {
  readonly dateStart: string;
  readonly dateEnd: string;
  readonly timeStart: string;
  readonly timeEnd: string;
  readonly timeIncrement: string;
  readonly slotRules: SlotRule[];
}

export interface TransportMethod {
  readonly transportMethod: CollectionDeliveryTypes;
  readonly isAvailable: boolean;
  readonly priority: number;
}

/**
 * Timetable for Fixter & Garage C&D
 */
export interface TimetableWithJourneys {
  readonly collectionDeliveryType: CollectionDeliveryTypes.FIXTER | CollectionDeliveryTypes.GARAGE;
  readonly collection: JourneyData;
  readonly delivery: JourneyData;
  readonly transportMethods: TransportMethod[];
}

/**
 * Timetable for Customer C&D with garage candidates
 */
export interface TimetableWithCustomerCD {
  readonly collectionDeliveryType: CollectionDeliveryTypes.CUSTOMER;
  readonly garages: GarageCandidate[];
  readonly transportMethods: TransportMethod[];
}

/**
 * Timetable for Customer C&D with selected garage candidate
 */
export interface TimetableWithCustomerCDGarage {
  readonly collectionDeliveryType: CollectionDeliveryTypes.CUSTOMER;
  readonly collection: JourneyData;
  readonly transportMethods: TransportMethod[];
}

export interface TimetableOutOfCoverage {
  readonly collectionDeliveryType: CollectionDeliveryTypes.OUT_OF_COVERAGE;
  readonly transportMethods: TransportMethod[];
}
